<template>
    <section>
        <el-form :model="playerForm" ref="playerForm" label-width="120px" v-loading="loading" style="padding-top: 40px;">
            <div style="padding-bottom: 20px">
                <span>最大表示件数</span>
            </div>
            <el-form-item label="関連動画" prop="related">
                <el-input-number v-model="playerForm.related" :min="1" :max="20"></el-input-number>
            </el-form-item>
            <el-form-item label="おすすめ動画" prop="recommend">
                <el-input-number v-model="playerForm.recommend" :min="1" :max="20"></el-input-number>
            </el-form-item>

            <div style="padding-bottom: 20px; padding-top: 40px;">
                <span>優先表示動画（おすすめ動画）</span>
            </div>
            <div v-for="index of count" :key="index">
                <el-form-item label="コンテンツ名" prop="contents">
                    <el-select v-model="playerForm.contents[index-1]" filterable @change="setContents()" clearable placeholder="コンテンツ名">
                        <el-option value=""></el-option>
                        <el-option v-for="item in allContents"
                            :key="item.id"
                            :value="item.id"
                            :label="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="margin-left: 300px">
            <el-button type="primary" @click.native="addSubmit" :loading="addLoading">登録</el-button>
        </div>
    </section>
</template>

<script>
    import * as ContentRequest from '../../api/content';
    import * as PlayerRequest from '../../api/player'
    import ElOption from "../../../node_modules/element-ui/packages/select/src/option.vue"

    export default {
        components: { ElOption },
        data() {
            return {
                playerForm: {
                    related: 10,
                    recommend: 10,
                    contents: []
                },
                count: 5,
                addLoading: false,
                allContents: [],
                valid: {
                    content: false,
                    limit: false
                },
                total: 10,
                loading: false
            }
        },
        async created() {
            this.loading = true
            this.addLoading = true
            await this.getContents()
            await this.getPlayer()
            this.loading = false
            this.addLoading = false
        },
        methods: {
            addSubmit: async function() {
                this.valid.content = false
                this.valid.limit = false
                await this.validate()
                if (this.valid.content) {
                    this.$message({
                        message: 'コンテンツに不備があります。',
                        type: 'error'
                    })
                } else if (this.valid.limit) {
                    this.$message({
                        message: 'おすすめ動画の最大表示件数よりも優先表示動画は少なくしてください。',
                        type: 'error'
                    })
                } else {
                    this.$confirm('登録してもよろしいですか？', '確認', {})
                        .then(async () => {
                            this.addLoading = true
                            this.playerForm.contents = await this.playerForm.contents.filter(content => content !== null)
                            this.playerForm.contents = await this.playerForm.contents.filter(content => content !== "")
                            const params = Object.assign({}, this.playerForm)
                            return await PlayerRequest.edit(params)
                        })
                        .then(async () => {
                            this.addLoading = false
                            this.$message({
                                message: '登録しました',
                                type: 'success'
                            })
                        })
                }
            },
            async getPlayer() {
                await PlayerRequest.find().then(async result => {
                    let contentList = new Array()
                    for (const val of result.data.contents) {
                        let result = val.contentId.trim()
                        const contents = await this.allContents.filter(content => content.id === val.contentId)
                        if (contents.length <= 0) {
                            result = null
                        }
                        contentList.push(result)
                    }
                    this.playerForm.contents = contentList
                    this.playerForm.related = result.data.related
                    this.playerForm.recommend = result.data.recommend
                })
            },
            async validate() {
                await this.playerForm.contents.map((val, key) => {
                    if (key > 0 && val !== "" && val !== null) {
                        if (this.playerForm.contents[key-1] === "" ||
                            this.playerForm.contents[key-1] === undefined ||
                            this.playerForm.contents[key-1] === null) {
                            this.valid.content = true
                        }
                    }
                })
                let content = await this.playerForm.contents.filter(content => content !== null)
                content = await content.filter(content => content !== "")
                const recommend = this.playerForm.recommend
                if (recommend < content.length) {
                    this.valid.limit = true
                }
            },
            async getContents() {
                await ContentRequest.count()
                    .then(res => {
                        this.total = res.data.count;
                    });
                const params = {
                    params: {
                        count: this.total
                    }
                }
                await ContentRequest
                    .searchAvailable(params)
                    .then(res => {
                        this.allContents = res.data.map(content => content)
                    })
            },
            async setContents() {
                this.loading = true
                this.addLoading = true
                await this.getContents()
                await this.playerForm.contents.map(selected => {
                    this.allContents = this.allContents.filter(content => content.id !== selected)
                })
                this.loading = false
                this.addLoading = false
            }
        }
    }

</script>




// WEBPACK FOOTER //
// Player.vue?610a8aa0